import React, {Fragment} from 'react';
import {Pressable, ScrollView, StyleSheet, View} from 'react-native';
import Animated, {FadeIn, FadeOut} from 'react-native-reanimated';
import {observer} from 'mobx-react-lite';

import {useSearchDispatch} from '../context/SearchContext';
import {useStores} from '../stores/use-stores';
import theme from '../style/theme';

import Text from './ui-controls/Text';
import {Icon} from './Icon';

const RangeSortOptions = observer(() => {
  const {globalStore, filterStore} = useStores();
  const searchDispatch = useSearchDispatch();

  const separator = () => {
    return <View style={styles.separator} />;
  };

  const selectSortOption = sortOption => {
    if (!sortOption) return;
    if (sortOption !== filterStore.selectedSort) {
      filterStore.setSelectedSort(sortOption);
      searchDispatch({type: 'SET_SORT', sortOptionId: sortOption.id});
    }
    globalStore.setFiltersVisible(false);
  };

  const renderSortOption = ({item, index}) => {
    const textStyle =
      item === filterStore.selectedSort
        ? [styles.plainText, styles.plainTextSelected]
        : styles.plainText;
    return (
      <Fragment key={item.id}>
        <Pressable onPress={() => selectSortOption(item)}>
          <View style={styles.plainRow}>
            <View style={{flexDirection: 'row', alignItems: 'center'}}>
              <View style={{width: 12}}>
                {item === filterStore.selectedSort && (
                  <Icon name="check" size={12} style={{color: theme.colour.icon.general.primary}} />
                )}
              </View>
              <Text numberOfLines={1} ellipsizeMode="tail" style={textStyle}>
                {item.name}
              </Text>
            </View>
          </View>
        </Pressable>
        {index < filterStore.sortOptions.length - 1 && separator()}
      </Fragment>
    );
  };

  return (
    <Animated.View
      entering={FadeIn.duration(150)}
      exiting={FadeOut.duration(100)}
      style={styles.container}>
      <ScrollView style={styles.scrollView}>
        {filterStore.sortOptions.map((item, index) => renderSortOption({item, index}))}
      </ScrollView>
      {filterStore.selectedSort && filterStore.selectedSort.id !== 'top_products' ? (
        <Pressable
          style={[styles.button, styles.buttonInverted]}
          onPress={() => selectSortOption(filterStore.topProducts)}>
          <Text style={[styles.buttonText, styles.buttonTextInverted]}>CLEAR SORT</Text>
        </Pressable>
      ) : null}
    </Animated.View>
  );
});

export default RangeSortOptions;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 8,
    paddingLeft: 0,
    marginBottom: 16,
  },
  headingText: {
    fontSize: 16,
    fontWeight: '600',
    color: theme.colour.text.heading.primary,
  },
  button: {
    backgroundColor: theme.colour.background.button.primary,
    width: '80%',
    borderRadius: 4,
    marginTop: 4,
    padding: 8,
    alignItems: 'center',
    alignSelf: 'center',
  },
  buttonText: {
    color: 'white',
    fontSize: 16,
  },
  buttonInverted: {
    backgroundColor: 'white',
    borderColor: theme.colour.border.general.primary,
    borderWidth: 1,
  },
  buttonTextInverted: {
    color: theme.colour.general.primary,
  },
  // Segment list
  scrollView: {
    width: '100%',
  },
  plainRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    paddingHorizontal: 5,
    left: 1,
  },
  radioButtonRow: {
    flexDirection: 'row',
    paddingLeft: 16,
    marginVertical: 4,
  },
  chevronText: {
    fontSize: 16,
  },
  chevron: {
    marginLeft: 8,
    marginRight: 4,
  },
  plainText: {
    fontSize: 16,
    marginLeft: 8,
    textTransform: 'capitalize',
  },
  plainTextSelected: {
    color: theme.colour.text.content.heading,
    fontWeight: 'bold',
  },
  separator: {
    marginVertical: 4,
    borderBottomWidth: 1,
    borderBottomColor: 'lightgrey',
  },
});
